import { render, staticRenderFns } from "./wx-config.vue?vue&type=template&id=3e5ae99a&scoped=true"
import script from "./wx-config.vue?vue&type=script&lang=js"
export * from "./wx-config.vue?vue&type=script&lang=js"
import style0 from "./wx-config.vue?vue&type=style&index=0&id=3e5ae99a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5ae99a",
  null
  
)

export default component.exports